import { defineMessages } from '@transcend-io/internationalization';

export const useDownloadZipMessages = defineMessages(
  'privacy-center.hooks.useDownloadZip',
  {
    countsOnlyMessage: {
      defaultMessage:
        'We found {count} files that matched your identifier for the datapoint: {title}',
    },
    downloadError: {
      defaultMessage:
        'Something went wrong while downloading the zip. Please reload the page and try again.',
    },
  },
);
